import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MoveRight } from "lucide-react";
import { useLang } from "@/i18n";
import Reveal from "./Reveal";

export default function Story() {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="about" data-testid="story" className="relative bg-white py-24 md:py-32">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-6">
          <Reveal>
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#d81f2a]">
              {t("story_overline")}
            </span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display text-3xl sm:text-4xl lg:text-5xl font-bold uppercase leading-[0.95] tracking-tight text-[#0f1115]">
              {t("story_title")}
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 max-w-xl font-body text-base md:text-lg text-[#5b6472] leading-relaxed">
              {t("story_body")}
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="mt-8 flex items-start gap-3 border-l-2 border-[#d81f2a] pl-5">
              <MoveRight className="w-5 h-5 text-[#d81f2a] mt-1 shrink-0" />
              <p className="font-display text-lg md:text-xl font-bold uppercase tracking-tight text-[#0f1115] leading-tight">
                {t("story_tagline")}
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.35}>
            <div className="mt-10">
              <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#5b6472]">{t("markets_label")}</div>
              <div className="mt-3 flex flex-wrap gap-3">
                {["TÜRKMENİSTAN", "ÖZBEKİSTAN"].map((m) => (
                  <span key={m} className="border border-black/12 px-4 py-2 font-display text-sm font-bold uppercase tracking-tight text-[#0f1115]">
                    {m}
                  </span>
                ))}
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-6 relative">
          <Reveal delay={0.15}>
            <div className="relative overflow-hidden border border-black/10">
              <motion.img
                style={{ y }}
                src="https://images.unsplash.com/photo-1494412574643-ff11b0a5c1c3"
                alt="DMD GROUP INT. uluslararası lojistik ve konteyner terminali"
                className="w-full h-[420px] lg:h-[560px] object-cover scale-110"
              />
            </div>
          </Reveal>
          <div className="absolute -bottom-6 -left-2 lg:-left-6 bg-[#d81f2a] text-white px-7 py-5">
            <div className="font-display text-4xl md:text-5xl font-extrabold leading-none">2018</div>
            <div className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em]">EST.</div>
          </div>
        </div>
      </div>
    </section>
  );
}
